import { render, staticRenderFns } from "./AdminMails.vue?vue&type=template&id=c1877030&"
import script from "./AdminMails.vue?vue&type=script&lang=js&"
export * from "./AdminMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports